import { METHODS, request } from '../axiosInstances';

type SearchProps = {
  q?: string;
};

export default {
  search: (params: SearchProps = {}) => request(METHODS.GET, 'review/assets/search/', { params }),
};
